export default __webpack_public_path__ + "static/media/oAuth.db328570.yaml";